module.exports = __webpack_public_path__ + "static/img/1319_phase_function_Paper_Points.ceb56a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1319_phase_function_Paper_Points.png
// module id = IQjN
// module chunks = 0